export default "__VITE_ASSET__662a71b0__"